import DataSource from './DataSource';

export default class ProductHistoryProduct {
	id: string;

	name: string | null;

	dataSource: DataSource | null;

	constructor(id: string, name: string | null = null, dataSource: DataSource | null = null) {
		this.id = id;
		this.name = name;
		this.dataSource = dataSource;
	}
}
